export const REGEX_EMAIL = /^(?!\.)[a-zA-Z0-9._%+-]+(?<!\.)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Allow letters, numbers, space, punctuation and special characters
export const REGEX_ALL_ALLOWED_SAFE_FILTER =
  /^(?!.*(<|>|--|0x|\bscript\b|on\w+=))[a-zA-Z0-9À-ÖØ-öø-ÿ\s,.\-!?;:()"'&@#$%^*+=_/\\[\]{}¡¿«»“”‘’…–—ºª€]+$/i;

// Allow letters, space, punctuation and special characters (without digits)
export const REGEX_LETTERS_PUNCTUATION_SAFE_FILTER =
  /^(?!.*(<|>|--|0x|\bscript\b|on\w+=))[a-zA-ZÀ-ÖØ-öø-ÿ\s,.\-!?;:()"'&@#$%^*+=_/\\[\]{}¡¿«»“”‘’…–—ºª€]+$/i;

// Allowing letters and space
export const REGEX_LETTERS_SPACE_SAFE_FILTER =
  /^(?!.*(<|>|--|0x|\bscript\b|on\w+=|{|}))[a-zA-ZÀ-ÖØ-öø-ÿ\s¡¿«»“”‘’…–—]+$/i;

// Allowing letters, numbers space comma dash forward slash fullstop and paranthesis
export const REGEX_ALPHA_NUMERIC_MORE_SAFE_FILTER =
  /^(?!.*(<|>|--|0x|\bscript\b|on\w+=))[a-zA-Z0-9À-ÖØ-öø-ÿ\s.,;:¿?¡!«»"'()\[\]{}ºª%€&/@+*#_$\^\\\-–—…]+$/i;

// Allowing letters, numbers, dash, space
export const REGEX_ALPHA_NUMERIC_DASH_SPACE_SAFE_FILTER =
  /^(?!.*(<|>|--|0x|\bscript\b|on\w+=|{|}))[a-zA-Z0-9À-ÖØ-öø-ÿ\-\s¡¿«»“”‘’…–—$\^]+$/i;

// Allowing letters, space and fullstop
export const REGEX_LETTERS_SPACE_FULLSTOP_SAFE_FILTER =
  /^(?!.*(<|>|--|0x|\bscript\b|on\w+=|{|}))[a-zA-ZÀ-ÖØ-öø-ÿ\s.¡¿«»“”‘’…–—$\^]+$/i;

// Allowing only digits
export const REGEX_NUMBERS_SAFE_FILTER =
  /^(?!.*(<|>|--|0x|\bscript\b|on\w+=|{|}))[0-9¡¿«»“”‘’…–—]+$/i;
